import React from 'react';

const NeonButton = ({ children, onClick, className = '', disabled = false, type = 'button', ...props }) => {
    return (
        <button
            type={type}
            className={`btn-neon ${className}`}
            onClick={onClick}
            disabled={disabled}
            style={{
                opacity: disabled ? 0.7 : 1,
                cursor: disabled ? 'not-allowed' : 'pointer'
            }}
            {...props}
        >
            {children}
        </button>
    );
};

export default NeonButton;
